export const updateState = (currentState: any = {}, newState: any = {}): any => ({ ...currentState, ...newState });